import { forwardRef } from 'react';
import { getBreadcrumbStyles } from './BreadcrumbStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Breadcrumb = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return jsx("ol", {
    css: getBreadcrumbStyles,
    ref: ref,
    "aria-label": "breadcrumb-list",
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList",
    ...rest,
    children: children
  });
});
Breadcrumb.displayName = 'Breadcrumb';

export { Breadcrumb };
//# sourceMappingURL=Breadcrumb.js.map
